import { FC } from "react";
import { cn } from "@/lib/utils";

export const marketStats: { label: string; value: string; sub?: string; placeholder?: boolean }[] = [
  { label: "Volume (Past hour)", value: "647,135,134.53 USDr" },
  { label: "Market Cap", placeholder: true, value: "—" },
  { label: "Circulating Supply", placeholder: true, value: "—" },
  { label: "Total Trades (Past hour)", value: "950" },
  { label: "Pending Buys", value: "64" },
];

interface MarketStatsProps {
  className?: string;
  itemClassName?: string;
  columnsClassName?: string;
}

export const MarketStats: FC<MarketStatsProps> = ({
  className,
  itemClassName,
  columnsClassName,
}) => (
  <div className={cn("grid h-fit grid-cols-2 gap-1 lg:grid-cols-5", columnsClassName, className)}>
    {marketStats.map((stat) => (
      <div
        key={stat.label}
        className={cn("sr-panel flex min-h-[92px] flex-1 items-start px-5 py-4", itemClassName)}
      >
        <div className="flex h-fit flex-col">
          <span className="mb-1.5 block text-[11px] font-medium text-sr-neutral-300">
            {stat.label}
          </span>
          <span className={`block text-base font-medium font-display ${stat.placeholder ? "text-sr-neutral-700" : "text-white"}`}>
            {stat.value}
          </span>
          <span
            className={`mt-0.5 block text-[11px] ${stat.sub ? "text-sr-neutral-300" : "invisible"}`}
            aria-hidden={!stat.sub}
          >
            {stat.sub ?? "placeholder"}
          </span>
        </div>
      </div>
    ))}
  </div>
);
